import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import BusinessProfile from "../../components/user/settings/BusinessProfile";
import StoreProfile from "../../components/user/settings/StoreProfile";
import { useState } from "react";
import PersonalProfile from "../../components/user/settings/PersonalProfile";
import Upgrade from "../../components/user/settings/Upgrade";
import Verification from "../../components/user/settings/Verification";


function Settings() {

  let navLink = [
    { title: "Business Profile", id: "business-profile" },
    { title: "Store Profile", id: "store-profile" },
    // { to: "#upload", title: "Upload", id: "upload" },
    { title: "Personal Profile", id: "profile" },
    { title: "Upgrade", id: "upgrade" },
    { title: "Verification", id: "verification" },
  ];

  let tabPage = [
    { component: <BusinessProfile />, id: "business-profile" },
    { component: <StoreProfile />, id: "store-profile" },
    // { component: <Upload />, id: "upload" },
    { component: <PersonalProfile />, id: "profile" },
    { component: <Upgrade />, id: "upgrade" },
    { component: <Verification />, id: "verification" },
  ];

  const [fillActive, setFillActive] = useState('business-profile');

  const handleTabs = (value) => {
    if (!value) {
      setFillActive('business-profile');
      return;
    }
    if (value === fillActive) {
      return;
    }
    setFillActive(value);
  };


  return (
    <>
      <AppWrapper
        pagename={"settings"}
      >
        <StyledSettings>
          <Title
            title={"Settings"}
            btnName={"Billing"}
            link={'billing'}
          />

          <div className="nav-tab">

            <ul className="nav nav-tabs">

              {navLink.map(({ title, id }, i) => {
                return (
                  <li className="nav-item" key={i}>
                    <a
                      className={`nav-link ${ fillActive === id && 'active' }`}
                      onClick={() => handleTabs(id)}
                    >
                      {title}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="tab-content">

            {tabPage.map(({ component, id }, i) =>
              <div
                className={`tab-pane fade ${ fillActive === id && 'show active' }`}
                key={i}
              >
                {component}
              </div>
            )}
          </div>

        </StyledSettings>
      </AppWrapper>

    </>
  );
}

export default Settings;

const StyledSettings = styled.div`

 a {
  font-size: smaller !important;

  &.nav-link {
  font-size: 1.2rem;
  font-weight: 500 !important;
  padding: 1rem 2rem;
  color: #828282 !important;
  border-bottom: transparent solid 2px !important;
  cursor: pointer; 

  &.active {
   color: var(--pry-bold-color) !important;
   border-bottom: var(--pry-bold-color) solid 2px !important;
   border-top: 0 !important;
   border-left: 0 !important;
   border-right: 0 !important;
  }
  
  :hover {
    color: var(--pry-color) !important;
   background-color: transparent !important;
   /* border-bottom: transparent solid 2px !important; */
   border-top: 0 !important;
   border-left: 0 !important;
   border-right: 0 !important;
  }
}
}

 ul.nav {
  background-color: var(--light-color);
  width: max-content !important;
  padding: 2px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 0rem !important;
}

 .nav-tab {
  overflow-x: scroll !important;
}

 /* .nav-tab::-webkit-scrollbar-track {
  border: none;
  background-color: var(--light-color) !important;
  width: fit-content;
  margin: 0 !important;
} */

 .nav-tab::-webkit-scrollbar-thumb {
  background: var(--sec-bold-color) !important;
  border-radius: 2rem;
}


.img-container {
  border-radius: 5rem !important;
  width: 7rem !important;
  height: 7rem !important;
  padding: 0 !important;
  display: flex !important;
  margin-top: 1rem !important;

  img {
   border-radius: 5rem !important;
 }
}



/* Staff */
/* Staff */
.all-staff h5 {
  width: fit-content;
  margin-left: auto !important;
  margin-right: auto !important;
}

.all-staff .list {
  cursor: pointer;
  transition: 0.3s ease;
  padding: 5px;
}
.all-staff .list:hover {
  background: #f5f9fd !important;
  border-radius: 5rem !important;
  padding: 5px;
}
.all-staff .dropdown-menu-right {
  right: auto !important;
  left: 0 !important;
}
.addstaff .dropdown-menu-right {
  right: auto !important;
  left: 0 !important;
}
/* Staff */

 .hide {
  display: none !important;
}
 .show {
  display: block !important;
}

`;